import {
  StyledHeaderButton,
  StyledAppHeaderDropdown,
  StyledNavLeftMenu,
  StyledNavRightMenu,
  StyledNavMenuItem,
  StyledMenuIcons,
  StyledAvatar,
  StyledMenuLogout,
  StyledDivider,
} from 'components/Layout/App/Header/Header.styles'
import { Flex } from 'components/common/styles'
import { HeaderProfileSectionProps } from 'components/Layout/App/Header/Header.types'
import {
  ITEM_GROUP_NUMBER,
  LEAVE_FEEDBACK_NAME,
  RIGHT_SIDE_GROUP,
} from 'constants/index'
import { Map } from 'immutable'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Link, withRouter, RouteComponentProps } from 'react-router-dom'
import { injectIntl, FormattedMessage, WrappedComponentProps } from 'react-intl'
import Avatar from '@material-ui/core/Avatar'
import MenuItem from '@material-ui/core/MenuItem'
import SvgIcon from '@material-ui/core/SvgIcon'
import Badge from '@material-ui/core/Badge'
import { getProfileMenu } from 'helpers/menuProfile'
import RoleHelper, { ROLE_FEATURE_MANAGER } from 'helpers/role'
import * as ROUTE from 'constants/appRouting'
import defaultAvatar from 'assets/img/default-avatar.png'
import FilterLicensee from 'components/Dashboard/FilterLicensee'
import 'styles/app/layout/nav-right.scss'
import { showFeedbackFormModal } from 'reducers/feedback/reducer'
import { ReactComponent as MenuIconLogout } from 'assets/img/menu/menuIconLogout.svg'
import { ReactComponent as AdminIcon } from 'assets/img/SAdminIcon.svg'
import messages from '../../translate'

const HeaderProfileSection = ({
  intl: { formatMessage },
  showFeedbackFormModal,
  roleLevel,
  userData,
  allowedToManageWorkflows,
}: HeaderProfileSectionProps & WrappedComponentProps & RouteComponentProps) => {
  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & SVGSVGElement) | null | HTMLElement
  >(null)
  const { name, pictureUrl, licensee, roles } = userData.toJS()
  const isSuperAdmin = roleLevel >= RoleHelper.ROLE_SUPERADMIN_LEVEL
  const menuItems = getProfileMenu(
    roleLevel,
    allowedToManageWorkflows,
    roles.includes(ROLE_FEATURE_MANAGER),
  )
  let itemGroupNumber = ITEM_GROUP_NUMBER

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <StyledHeaderButton
        onClick={({ currentTarget }) => {
          setAnchorEl(currentTarget)
        }}>
        <Badge
          badgeContent={
            isSuperAdmin ? <SvgIcon component={AdminIcon} /> : null
          }>
          <Avatar
            component="div"
            src={pictureUrl || defaultAvatar}
            alt="name"
          />
        </Badge>
      </StyledHeaderButton>
      <StyledAppHeaderDropdown
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          className: 'right-menu-paper',
        }}>
        <StyledNavLeftMenu>
          {isSuperAdmin && (
            <MenuItem button>
              <FilterLicensee />
            </MenuItem>
          )}
          {menuItems.map(({ path, alt, name, icon, group }) => {
            if (typeof group === 'number') {
              let divider = null

              if (itemGroupNumber !== group) {
                itemGroupNumber = group
                divider = <StyledDivider />
              }

              return (
                <li key={name}>
                  {divider}
                  <StyledNavMenuItem
                    component="div"
                    button
                    onClick={handleClose}
                    key={alt}>
                    <Link
                      to={path}
                      onClick={() => {
                        if (name === LEAVE_FEEDBACK_NAME) {
                          showFeedbackFormModal(true)
                        }
                      }}>
                      <StyledMenuIcons>{icon}</StyledMenuIcons>
                      <span>
                        {formatMessage(messages[name as keyof typeof messages])}
                      </span>
                    </Link>
                  </StyledNavMenuItem>
                </li>
              )
            }

            return null
          })}
        </StyledNavLeftMenu>
        <StyledNavRightMenu>
          <MenuItem button onClick={handleClose}>
            <Flex align="center">
              <StyledAvatar
                component="div"
                src={pictureUrl || defaultAvatar}
                alt="name"
              />
              <div>
                <strong>{name || formatMessage(messages.anonymous)}</strong>
                &nbsp;(
                {licensee && !isSuperAdmin ? (
                  licensee.name
                ) : (
                  <FormattedMessage {...messages.company_name} />
                )}
                )
              </div>
            </Flex>
          </MenuItem>
          {menuItems.map(({ path, alt, name, icon, group }) => {
            if (group === RIGHT_SIDE_GROUP) {
              return (
                <StyledNavMenuItem button onClick={handleClose} key={alt}>
                  <Link to={path}>
                    <StyledMenuIcons>{icon}</StyledMenuIcons>
                    <span>
                      {formatMessage(messages[name as keyof typeof messages])}
                    </span>
                  </Link>
                </StyledNavMenuItem>
              )
            }

            return null
          })}
          <StyledMenuLogout button onClick={handleClose}>
            <Link to={ROUTE.LOGOUT}>
              <StyledMenuIcons>
                <MenuIconLogout />
              </StyledMenuIcons>
              <span>{formatMessage(messages.logout)}</span>
            </Link>
          </StyledMenuLogout>
        </StyledNavRightMenu>
      </StyledAppHeaderDropdown>
    </>
  )
}

export default injectIntl(
  withRouter(
    connect(
      (state: {
        getIn: (path: Array<string>) => Map<string, {}> | number | boolean
      }) => ({
        roleLevel: state.getIn(['profile', 'roleLevel']) as number,
        userData: state.getIn(['profile', 'profile']) as Map<string, {}>,
        allowedToManageWorkflows: state.getIn([
          'profile',
          'profile',
          'grantedManageWorkflows',
        ]) as boolean,
      }),
      {
        showFeedbackFormModal,
      },
    )(HeaderProfileSection),
  ),
)
